import React, { createContext, useState } from "react";

let ProductContext = createContext();

const initialState = 0;

const ProductContextProvider = props => {
  const [selectedColorKey, setSelectedColorKey] = useState(initialState);

  return (
    <ProductContext.Provider
      value={{
        selectedColorKey,
        setSelectedColorKey
      }}
    >
      {props.children}
    </ProductContext.Provider>
  );
};

let ProductContextConsumer = ProductContext.Consumer;
export { ProductContext, ProductContextProvider, ProductContextConsumer };
